// import { styles } from "@components/PreviewPdf/PreviewPdf.style";
// import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
// import { format } from "date-fns";
// import React from "react";
// import { useTranslation } from "react-i18next";
// import QuoteStatusPDF from "./QuoteStatusPDF/QuoteStatusPDF";

// // Styles

// // Main component
// const InvoicePreviewPDF = ({
//   invoiceData,
//   title,
//   isAvoir,
//   paymentInfo,
//   isQuote,
// }) => {
//   const { taxTVA, total, totalHT } = invoiceData;
//   const itemsToDisplay = isQuote ? invoiceData?.items : invoiceData?.offers;
//   console.log("🚀 ~ invoiceDatass:", invoiceData);

//   const devise = "€";

//   // Calculate totals from line items
//   const { t } = useTranslation();
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         {/* Header */}
//         <View style={styles.header}>
//           <Text style={styles.title}>{t(title) || "Facture"}</Text>
//           <View>
//             <Text style={styles.invoiceNumber}>
//               {t("invoice.number")}
//               {isAvoir
//                 ? t("invoice.credit.credit_note")
//                 : isQuote
//                 ? t("invoice.quote.quote")
//                 : t("invoice.invoice")}
//               {isAvoir
//                 ? invoiceData?.numeroCreditNote
//                 : isQuote
//                 ? invoiceData?.numeroDevis
//                 : invoiceData?.numeroInvoice || "En attente"}
//             </Text>
//             <Text style={styles.date}>{invoiceData?.dateDeFacturation}</Text>
//           </View>
//         </View>

//         {/* Émetteur & Destinataire */}
//         <View style={styles.twoColumns}>
//           <View style={styles.column}>
//             <Text style={styles.sectionTitle}>{t("invoice.emitter")}</Text>
//             <Text>
//               {t("invoice.company")} :{" "}
//               {isQuote ? invoiceData?.companyId?.name : invoiceData?.sellerName}
//             </Text>
//             <Text>
//               {t("invoice.email")} :{" "}
//               {isQuote
//                 ? invoiceData?.companyId?.email
//                 : invoiceData?.sellerEmail}
//             </Text>
//           </View>
//           <View style={styles.receiverColumn}>
//             <Text style={styles.sectionTitle}>{t("invoice.receiver")}</Text>
//             <Text>
//               {t("invoice.company")} :{" "}
//               {isQuote
//                 ? invoiceData?.idClient?.name
//                 : invoiceData?.clientId?.name}
//             </Text>
//             <Text>
//               {t("invoice.client")} :{" "}
//               {isQuote
//                 ? invoiceData?.idUserClient?.name
//                 : invoiceData?.clientName}
//             </Text>
//             <Text>
//               {t("invoice.address")} :{" "}
//               {isQuote
//                 ? invoiceData?.idClient?.address
//                 : invoiceData?.clientAddress}
//             </Text>
//             <Text>
//               {t("invoice.email")} :{" "}
//               {isQuote
//                 ? invoiceData?.idClient?.email
//                 : invoiceData?.clientEmail}
//             </Text>
//           </View>
//         </View>

//         {/* Custom fields */}
//         {(invoiceData?.engagementId ||
//           invoiceData?.extraInputs?.length > 0) && (
//           <View style={{ marginBottom: 20 }}>
//             <Text style={styles.sectionTitle}>{t("invoice.info")}</Text>
//             {invoiceData?.engagementId && (
//               <Text>
//                 <Text style={styles.bold}>{t("invoice.engagement_id")} :</Text>{" "}
//                 {invoiceData.engagementId}
//               </Text>
//             )}
//             {invoiceData?.extraInputs?.map((input, idx) => (
//               <Text key={idx}>
//                 <Text style={styles.bold}>{input.label}:</Text> {input.value}
//               </Text>
//             ))}
//           </View>
//         )}

//         {/* Line items detail */}
//         <View>
//           <Text style={styles.sectionTitle}>{t("invoice.details")}</Text>
//           <View style={styles.detailTable}>
//             <View style={styles.tableRowHeader}>
//               <Text style={styles.cell}>{t("invoice.description")}</Text>
//               <Text style={styles.cell}>{t("invoice.unit_price")}</Text>
//               <Text style={styles.cell}>{t("invoice.quantity")}</Text>
//               <Text style={styles.cell}>{t("invoice.vat_percent")}</Text>
//               <Text style={styles.cell}>{t("invoice.discount")}</Text>
//               <Text style={styles.cell}>{t("invoice.total_ht")}</Text>
//             </View>

//             {itemsToDisplay?.map((item, idx) => {
//               console.log("itemmmmmmmmm", item);

//               const offer = item.idOffer || {};
//               const quantity = parseFloat(item.quantity) || 0;
//               const price = isQuote
//                 ? parseFloat(item?.unitPrice)
//                 : parseFloat(item?.price ?? offer.price) || 0;
//               const TVA = isQuote
//                 ? item.tva + "%"
//                 : parseFloat(item.TVA ?? offer.tva) || 0;
//               const reductionPercent = parseFloat(item.reductionPercent) || 0;
//               const reductionAmount = isQuote
//                 ? item?.reduction
//                 : parseFloat(item.reductionAmount) || 0;
//               const description = isQuote
//                 ? item?.designation
//                 : item?.description ?? offer?.description ?? "-";
//               console.log(
//                 "🚀 ~ {itemsToDisplay?.map ~ description:",
//                 description
//               );

//               let reductionValue = 0;

//               if (reductionPercent > 0) {
//                 reductionValue = (price * quantity * reductionPercent) / 100;
//               } else if (reductionAmount > 0) {
//                 reductionValue = reductionAmount;
//               }

//               const totalAfterReduction = price * quantity - reductionValue;

//               const lineHT = Math.max(0, totalAfterReduction);
//               const lineTTC = lineHT * (1 + TVA / 100);

//               return (
//                 <View key={idx} style={styles.tableRow}>
//                   <Text style={styles.cell}>{description}</Text>
//                   <Text style={styles.cell}>
//                     {price?.toFixed(2)} {devise}
//                   </Text>
//                   <Text style={styles.cell}>{quantity}</Text>
//                   <Text style={styles.cell}>{TVA}</Text>
//                   <Text style={styles.cell}>
//                     {reductionPercent > 0 ? `${reductionPercent}%` : ""}
//                     {reductionPercent > 0 && reductionAmount > 0 ? " + " : ""}
//                     {reductionAmount > 0
//                       ? `(- ${reductionAmount?.toFixed(2)} ${devise})`
//                       : "-"}
//                   </Text>
//                   <Text style={styles.cell}>
//                     {lineHT?.toFixed(2)} {devise}
//                   </Text>
//                 </View>
//               );
//             })}

//             {/* Additional fees row if exists */}
//             {invoiceData?.additionalFees && (
//               <View style={styles.tableRow}>
//                 <Text style={[styles.cell, { flex: 5 }]}>
//                   {t("invoice.additional_fees")}
//                 </Text>
//                 <Text style={styles.cell}></Text>
//                 <Text style={styles.cell}></Text>
//                 <Text style={styles.cell}></Text>
//                 <Text style={styles.cell}></Text>
//                 <Text style={styles.cell}>
//                   {parseFloat(invoiceData.additionalFees)?.toFixed(2)} {devise}
//                 </Text>
//                 <Text style={styles.cell}>
//                   {parseFloat(invoiceData.additionalFees)?.toFixed(2)} {devise}
//                 </Text>
//               </View>
//             )}

//             {/* Totals section */}
//             <View style={[styles.tableRow, { justifyContent: "flex-end" }]}>
//               <Text style={[styles.cell, { textAlign: "right" }]}>
//                 {t("invoice.total_ht")} :
//               </Text>
//               <Text style={styles.cell}>
//                 {totalHT?.toFixed(2)} {devise}
//               </Text>
//             </View>

//             <View style={[styles.tableRow, { justifyContent: "flex-end" }]}>
//               <Text style={[styles.cell, { textAlign: "right" }]}>
//                 {t("invoice.total_tva")} :
//               </Text>
//               <Text style={styles.cell}>
//                 {isQuote
//                   ? (
//                       (invoiceData?.tvaRate * invoiceData?.totalHT) /
//                       100
//                     ).toFixed(2)
//                   : taxTVA?.toFixed(2)}{" "}
//                 {devise}
//               </Text>
//             </View>

//             <View style={[styles.tableRow, { justifyContent: "flex-end" }]}>
//               <Text style={[styles.cell, { textAlign: "right" }]}>
//                 {t("invoice.total_ttc")} :
//               </Text>
//               <Text style={styles.cell}>
//                 {isQuote
//                   ? invoiceData?.totalTTC?.toFixed(2)
//                   : total?.toFixed(2)}{" "}
//                 {devise}
//               </Text>
//             </View>

//             {isQuote && <QuoteStatusPDF status={invoiceData?.status} />}
//           </View>
//         </View>
//         {isQuote && (
//           <View style={styles.quoteDetails}>
//             <View style={styles.quoteRow}>
//               <Text style={styles.quoteLabel}>
//                 {t("quote.estimatedDuration")} :
//               </Text>
//               <Text style={styles.quoteValue}>
//                 {invoiceData?.estimatedDuration} {t("quote.days")}
//               </Text>
//             </View>
//             <View style={styles.quoteRow}>
//               <Text style={styles.quoteLabel}>
//                 {t("quote.validityPeriod")} :
//               </Text>
//               <Text style={styles.quoteValue}>
//                 {invoiceData?.validityPeriod} {t("quote.days")}
//               </Text>
//             </View>
//             <View style={styles.quoteRow}>
//               <Text style={styles.quoteLabel}>{t("quote.issueDate")} :</Text>
//               <Text style={styles.quoteValue}>
//                 {invoiceData?.issueDate
//                   ? format(new Date(invoiceData.issueDate), "dd/MM/yyyy")
//                   : ""}
//               </Text>
//             </View>
//           </View>
//         )}

//         {/* Footer */}
//         <View
//           style={{
//             marginTop: 70,
//             borderTopWidth: 1,
//             borderTopColor: "#ccc",
//             paddingTop: 10,
//           }}>
//           <Text style={styles.sectionTitle}>{t("invoice.conditions")}</Text>
//           <Text>
//             <Text style={styles.bold}>{t("invoice.payment_method")} :</Text>{" "}
//             {invoiceData?.paymentMethod ||
//               invoiceData?.paymentTerms ||
//               t("invoice.no_payment_method")}
//           </Text>
//           <Text>
//             <Text style={styles.bold}>{t("invoice.note")} :</Text>{" "}
//             {invoiceData?.note || t("invoice.no_note")}
//           </Text>
//           <Text>
//             <Text style={styles.bold}>
//               {t("invoice.executionConditions")} :
//             </Text>{" "}
//             {invoiceData?.executionConditions ||
//               t("invoice.no_executionConditions")}
//           </Text>

//           <View style={{ marginTop: 10 }}>
//             <Text style={styles.sectionTitle}>{t("invoice.bank_info")}</Text>
//             <Text>
//               {t("invoice.bank")}: {paymentInfo?.name || ""}
//             </Text>
//             <Text>
//               {t("invoice.iban")}: {paymentInfo?.iban || ""}
//             </Text>
//             <Text>
//               {t("invoice.bic")}: {paymentInfo?.bic || ""}
//             </Text>
//             <Text>
//               {t("invoice.rib")}: {paymentInfo?.rib || ""}
//             </Text>
//           </View>

//           <View
//             style={{
//               marginTop: 10,
//               flexDirection: "row",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}>
//             <Image src="/logo.png" style={{ width: 80, height: 40 }} />
//             <Text style={{ fontSize: 9, color: "#555" }}>
//               {t("invoice.company_signature")}
//             </Text>
//           </View>

//           <Text
//             render={({ pageNumber, totalPages }) =>
//               `Page ${pageNumber} / ${totalPages}`
//             }
//             style={{
//               marginTop: 5,
//               fontSize: 9,
//               color: "#999",
//               textAlign: "right",
//             }}
//           />
//         </View>
//       </Page>
//     </Document>
//   );
// };

// export default InvoicePreviewPDF;
import { styles } from "@components/PreviewPdf/PreviewPdf.style";
import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import QuoteStatusPDF from "./QuoteStatusPDF/QuoteStatusPDF";

// Main component
const InvoicePreviewPDF = ({
  invoiceData,
  title,
  isAvoir,
  paymentInfo,
  isQuote,
}) => {
  const { taxTVA, total, totalHT } = invoiceData;
  const itemsToDisplay = isQuote ? invoiceData?.items : invoiceData?.offers;
  console.log("🚀 ~ invoiceDatassss:", invoiceData);

  const devise = "€";
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>{t(title) || "Facture"}</Text>
          <View>
            <Text style={styles.invoiceNumber}>
              {t("invoice.number")}
              {isAvoir
                ? t("invoice.credit.credit_note")
                : isQuote
                ? t("invoice.quote.quote")
                : t("invoice.invoice")}
              {isAvoir
                ? invoiceData?.numeroCreditNote
                : isQuote
                ? invoiceData?.numeroDevis
                : invoiceData?.numeroInvoice || "En attente"}
            </Text>
            <Text style={styles.date}>{invoiceData?.dateDeFacturation}</Text>
          </View>
        </View>

        {/* Émetteur & Destinataire */}
        <View style={styles.twoColumns}>
          <View style={styles.column}>
            <Text style={styles.sectionTitle}>{t("invoice.emitter")}</Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.company")} :</Text>{" "}
              {isQuote ? invoiceData?.companyId?.name : invoiceData?.sellerName}
            </Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.email")} :</Text>{" "}
              {isQuote
                ? invoiceData?.companyId?.email
                : invoiceData?.sellerEmail}
            </Text>
          </View>
          <View style={styles.receiverColumn}>
            <Text style={styles.sectionTitle}>{t("invoice.receiver")}</Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.company")} :</Text>{" "}
              {isQuote
                ? invoiceData?.idClient?.name
                : invoiceData?.clientId?.name}
            </Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.client")} :</Text>{" "}
              {isQuote
                ? invoiceData?.idUserClient?.name
                : invoiceData?.clientName}
            </Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.address")} :</Text>{" "}
              {isQuote
                ? invoiceData?.idClient?.address
                : invoiceData?.clientAddress}
            </Text>
            <Text style={styles.footerText}>
              <Text style={styles.bold}>{t("invoice.email")} :</Text>{" "}
              {isQuote
                ? invoiceData?.idClient?.email
                : invoiceData?.clientEmail}
            </Text>
          </View>
        </View>

        {/* Custom fields */}
        {(invoiceData?.engagementId ||
          invoiceData?.extraInputs?.length > 0) && (
          <View style={styles.customFieldsSection}>
            <Text style={styles.sectionTitle}>{t("invoice.info")}</Text>
            {invoiceData?.engagementId && (
              <Text style={styles.footerText}>
                <Text style={styles.bold}>{t("invoice.engagement_id")} :</Text>{" "}
                {invoiceData.engagementId}
              </Text>
            )}
            {invoiceData?.extraInputs?.map((input, idx) => (
              <Text key={idx} style={styles.footerText}>
                <Text style={styles.bold}>{input.label}:</Text> {input.value}
              </Text>
            ))}
          </View>
        )}

        {/* Line items detail */}
        <View>
          <Text style={styles.sectionTitle}>{t("invoice.details")}</Text>
          <View style={styles.detailTable}>
            <View style={styles.tableRowHeader}>
              <Text style={styles.cell}>{t("invoice.description")}</Text>
              <Text style={styles.cell}>{t("invoice.unit_price")}</Text>
              <Text style={styles.cell}>{t("invoice.quantity")}</Text>
              <Text style={styles.cell}>{t("invoice.vat_percent")}</Text>
              <Text style={styles.cell}>{t("invoice.discount")}</Text>
              <Text style={styles.cell}>{t("invoice.total_ht")}</Text>
            </View>

            {itemsToDisplay?.map((item, idx) => {
              const offer = item.idOffer || {};
              const quantity = parseFloat(item.quantity) || 0;
              const price = isQuote
                ? parseFloat(item?.unitPrice)
                : parseFloat(item?.price ?? offer.price) || 0;
              const TVA = isQuote
                ? item.tva + "%"
                : parseFloat(item.TVA ?? offer.tva) || 0;
              const reductionPercent = parseFloat(item.reductionPercent) || 0;
              const reductionAmount = isQuote
                ? item?.reduction
                : parseFloat(item.reductionAmount) || 0;
              const description = isQuote
                ? item?.designation
                : item?.description ?? offer?.description ?? "-";

              let reductionValue = 0;
              if (reductionPercent > 0) {
                reductionValue = (price * quantity * reductionPercent) / 100;
              } else if (reductionAmount > 0) {
                reductionValue = reductionAmount;
              }

              const totalAfterReduction = price * quantity - reductionValue;
              const lineHT = Math.max(0, totalAfterReduction);

              return (
                <View key={idx} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlternate}>
                  <Text style={styles.cellDescription}>{description}</Text>
                  <Text style={styles.cellNumber}>
                    {price?.toFixed(2)} {devise}
                  </Text>
                  <Text style={styles.cellNumber}>{quantity}</Text>
                  <Text style={styles.cellNumber}>{TVA}</Text>
                  <Text style={styles.cellNumber}>
                    {reductionPercent > 0 ? `${reductionPercent}%` : ""}
                    {reductionPercent > 0 && reductionAmount > 0 ? " + " : ""}
                    {reductionAmount > 0
                      ? `(- ${reductionAmount?.toFixed(2)} ${devise})`
                      : "-"}
                  </Text>
                  <Text style={styles.cellNumber}>
                    {lineHT?.toFixed(2)} {devise}
                  </Text>
                </View>
              );
            })}

            {/* Additional fees row */}
            {invoiceData?.additionalFees && (
              <View style={styles.tableRowAlternate}>
                <Text style={styles.cellDescription}>
                  {t("invoice.additional_fees")}
                </Text>
                <Text style={styles.cellNumber}></Text>
                <Text style={styles.cellNumber}></Text>
                <Text style={styles.cellNumber}></Text>
                <Text style={styles.cellNumber}></Text>
                <Text style={styles.cellNumber}>
                  {parseFloat(invoiceData.additionalFees)?.toFixed(2)} {devise}
                </Text>
                <Text style={styles.cellNumber}>
                  {parseFloat(invoiceData.additionalFees)?.toFixed(2)} {devise}
                </Text>
              </View>
            )}
          </View>

          {/* Beautiful Totals Section */}
          <View style={styles.totalsSection}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>{t("invoice.total_ht")} :</Text>
              <Text style={styles.totalValue}>
                {totalHT?.toFixed(2)} {devise}
              </Text>
            </View>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>{t("invoice.total_tva")} :</Text>
              <Text style={styles.totalValue}>
                {isQuote
                  ? ((invoiceData?.tvaRate * invoiceData?.totalHT) / 100).toFixed(2)
                  : taxTVA?.toFixed(2)}{" "}
                {devise}
              </Text>
            </View>
            <View style={styles.grandTotalRow}>
              <Text style={styles.grandTotalLabel}>{t("invoice.total_ttc")} :</Text>
              <Text style={styles.grandTotalValue}>
                {isQuote ? invoiceData?.totalTTC?.toFixed(2) : total?.toFixed(2)}{" "}
                {devise}
              </Text>
            </View>
          </View>

          {isQuote && <QuoteStatusPDF status={invoiceData?.status} />}
        </View>

        {/* Quote extra details */}
        {isQuote && (
          <View style={styles.quoteDetails}>
            <View style={styles.quoteRow}>
              <Text style={styles.quoteLabel}>{t("quote.issueDate")} :</Text>
              <Text style={styles.quoteValue}>
                {invoiceData?.issueDate
                  ? format(new Date(invoiceData.issueDate), "dd/MM/yyyy")
                  : ""}
              </Text>
            </View>
          </View>
        )}

        {/* Beautiful Footer */}
        <View style={styles.footerSection}>
          <Text style={styles.footerTitle}>{t("invoice.conditions")}</Text>
          <Text style={styles.footerText}>
            <Text style={styles.bold}>{t("invoice.payment_method")} :</Text>{" "}
            {invoiceData?.paymentMethod ||
              invoiceData?.paymentTerms ||
              t("invoice.no_payment_method")}
          </Text>
          <Text style={styles.footerText}>
            <Text style={styles.bold}>{t("invoice.note")} :</Text>{" "}
            {invoiceData?.note || t("invoice.no_note")}
          </Text>
          {invoiceData?.executionConditions && (
            <Text style={styles.footerText}>
              <Text style={styles.bold}>
                {t("invoice.executionConditions")} :
              </Text>{" "}
              {invoiceData?.executionConditions ||
                t("invoice.no_executionConditions")}
            </Text>
          )}

          <View style={styles.bankInfo}>
            <Text style={styles.bankTitle}>{t("invoice.bank_info")}</Text>
            <View style={styles.bankRow}>
              <Text style={styles.bankLabel}>{t("invoice.bank")}:</Text>
              <Text style={styles.bankValue}>{paymentInfo?.name || ""}</Text>
            </View>
            <View style={styles.bankRow}>
              <Text style={styles.bankLabel}>{t("invoice.iban")}:</Text>
              <Text style={styles.bankValue}>{paymentInfo?.iban || ""}</Text>
            </View>
            <View style={styles.bankRow}>
              <Text style={styles.bankLabel}>{t("invoice.bic")}:</Text>
              <Text style={styles.bankValue}>{paymentInfo?.bic || ""}</Text>
            </View>
            <View style={styles.bankRow}>
              <Text style={styles.bankLabel}>{t("invoice.rib")}:</Text>
              <Text style={styles.bankValue}>{paymentInfo?.rib || ""}</Text>
            </View>
          </View>

          <View style={styles.signatureSection}>
            <Image src="/logo.png" style={styles.logo} />
            <Text style={styles.signatureText}>
              {t("invoice.company_signature")}
            </Text>
          </View>

          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} / ${totalPages}`
            }
            style={styles.pageNumber}
          />
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePreviewPDF;
